import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Select, Input} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import {SearchOutlined, ArrowLeftOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import history from '../../../routes/history'
const storage = window.localStorage

@inject('intelligentOutboundCallDetailsStore', 'manualOutboundCallStore', 'accountStore')
@observer
class SearchForm extends Component {
  state = {
    record: this.props?.location?.state?.record,
  }
  formRef = React.createRef()

  componentDidMount() {
    const {intelligentOutboundCallDetailsStore, manualOutboundCallStore, accountStore, location} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    intelligentOutboundCallDetailsStore.onSearchJobAction({
      taskId: location?.search?.split('?')[1]?.split('&')[0],
      callStatus: '',
      calleeNo: '',
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
      page: 1, 
      size: PAGE_SIZE_DEFAULT
    })
    manualOutboundCallStore.onGetStatus('AiCallStatus')
  }

  handleSearch = () => {
    const {intelligentOutboundCallDetailsStore, accountStore, location} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        'taskId': location?.search?.split('?')[1]?.split('&')[0],
        'callStatus': fieldsValue?.callStatus,
        'calleeNo': fieldsValue?.calleeNo,
        'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
        'page': 1,
        'size': PAGE_SIZE_DEFAULT
      }
      intelligentOutboundCallDetailsStore.onSearchJobAction(params)
    }).catch(err => {
    })
  }
  handleBack = () => {
      history.push(`/intelligentCallManagement`)
  }

  render() {
    const { manualOutboundCallStore, t } = this.props
    const { statusList } = manualOutboundCallStore
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.intelligentCallDetails`)} - {this.state.record?.taskName}
          </div>
          <Row gutter={[10, 10]}>
            <Col span={6}>
              <Form.Item name="callStatus" label={t(`outboundCall.callStatus`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {statusList?.map(item => (<Select.Option key={item.code} value={item.name}>{item.name}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="calleeNo" label={t(`marketingManagement.phone`)}
                // rules={[{
                //   message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.calleeNo`)} ${t(`general.withoutSpecialChats`)}`,
                //   pattern: new RegExp(regPhone)
                // }]}
              >
                <Input maxLength={11} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col span={12} style={{textAlign: 'right', marginTop: 30}}>
              <Button onClick={this.handleSearch} className="ant-btn-red">{t(`general.search`)}</Button>
              <Button type="primary" onClick={() => this.handleBack()} icon={<ArrowLeftOutlined/>}>{t(`general.back`)}</Button>
            </Col>
          </Row>
        </Form>
      </>
    )
  }
}

export default withTranslation()(SearchForm)
